import { ChangeAbs } from "app/components/React/Table/cells/ChangeAbs";
import { DefaultCellRightAlign } from "../../../components/React/Table/cells/DefaultCellRightAlign";
import { BounceRate, ChangePercentage, DefaultCell } from "../../../components/React/Table/cells/index";
import { DefaultCellHeader, DefaultCellHeaderRightAlign } from "../../../components/React/Table/headerCells/index";
import { translate } from "app/filters/i18nFilter";

const kw = {
    field: "Kw",
    fixed: true,
    width: 400,
    sortable: false,
    cellComponent: DefaultCell,
    get displayName() {
        return translate("segment.conversion.table.column.kw");
    },
    visible: true,
    headerComponent: DefaultCellHeader,
    showTotalCount: true,
};
const swScore = {
    field: "SwScore",
    get displayName() {
        return translate("segment.conversion.table.column.swscore");
    },
    type: "double",
    format: "swNumber",
    sortable: true,
    isSorted: false,
    cellComponent: DefaultCellRightAlign,
    headerComponent: DefaultCellHeaderRightAlign,
    sortDirection: "asc",
    get tooltip() {
        return translate("segment.conversion.table.column.swscore.tooltip");
    },
    visible: true,
    width: 160,
};
const upv = {
    field: "Upv",
    get displayName() {
        return translate("segment.conversion.table.column.upv");
    },
    type: "double",
    format: "pureNumberFixedZeros",
    sortable: true,
    isSorted: false,
    cellComponent: DefaultCellRightAlign,
    headerComponent: DefaultCellHeaderRightAlign,
    sortDirection: "desc",
    get tooltip() {
        return translate("segment.conversion.table.column.upv.tooltip");
    },
    visible: true,
    width: 160,
};
const upvCompare = {
    field: "UpvCompare",
    get displayName() {
        return translate("segment.conversion.table.column.upv.compare");
    },
    type: "double",
    format: "pureNumberFixedZeros",
    sortable: true,
    isSorted: false,
    cellComponent: DefaultCellRightAlign,
    headerComponent: DefaultCellHeaderRightAlign,
    sortDirection: "desc",
    get tooltip() {
        return translate("segment.conversion.table.column.upv.compare.tooltip");
    },
    visible: false,
    width: 160,
};
const upvDelta = {
    field: "UpvDelta",
    get displayName() {
        return translate("segment.conversion.table.column.upv.delta");
    },
    type: "double",
    format: "swNumber",
    sortable: true,
    isSorted: false,
    cellComponent: ChangeAbs,
    headerComponent: DefaultCellHeaderRightAlign,
    sortDirection: "desc",
    get tooltip() {
        return translate("segment.conversion.table.column.upv.delta.tooltip");
    },
    visible: true,
    width: 160,
};
const upvGrowth = {
    field: "UpvGrowth",
    get displayName() {
        return translate("segment.conversion.table.column.upv.growth");
    },
    type: "double",
    format: "percentagesign",
    sortable: true,
    isSorted: false,
    cellComponent: ChangePercentage,
    headerComponent: DefaultCellHeaderRightAlign,
    sortDirection: "desc",
    get tooltip() {
        return translate("segment.conversion.table.column.upv.growth.tooltip");
    },
    visible: true,
    width: 160,
};
const cv = {
    field: "Cv",
    get displayName() {
        return translate("segment.conversion.table.column.cv");
    },
    type: "double",
    format: "pureNumberFixedZeros",
    sortable: true,
    isSorted: false,
    cellComponent: DefaultCellRightAlign,
    headerComponent: DefaultCellHeaderRightAlign,
    sortDirection: "desc",
    get tooltip() {
        return translate("segment.conversion.table.column.cv.tooltip");
    },
    visible: true,
    width: 150,
};
const cvCompare = {
    field: "CvCompare",
    get displayName() {
        return translate("segment.conversion.table.column.cv.compare");
    },
    type: "double",
    format: "pureNumberFixedZeros",
    sortable: true,
    isSorted: false,
    cellComponent: DefaultCellRightAlign,
    headerComponent: DefaultCellHeaderRightAlign,
    sortDirection: "desc",
    get tooltip() {
        return translate("segment.conversion.table.column.cv.compare.tooltip");
    },
    visible: false,
    width: 150,
};
const cvDelta = {
    field: "CvDelta",
    get displayName() {
        return translate("segment.conversion.table.column.cv.delta");
    },
    type: "double",
    format: "swNumber",
    sortable: true,
    isSorted: false,
    cellComponent: ChangeAbs,
    headerComponent: DefaultCellHeaderRightAlign,
    sortDirection: "desc",
    get tooltip() {
        return translate("segment.conversion.table.column.cv.delta.tooltip");
    },
    visible: true,
    width: 150,
};
const cvGrowth = {
    field: "CvGrowth",
    get displayName() {
        return translate("segment.conversion.table.column.cv.growth");
    },
    type: "double",
    format: "percentagesign",
    sortable: true,
    isSorted: false,
    cellComponent: ChangePercentage,
    headerComponent: DefaultCellHeaderRightAlign,
    sortDirection: "desc",
    get tooltip() {
        return translate("segment.conversion.table.column.cv.growth.tooltip");
    },
    visible: false,
    width: 160,
};
const cvr = {
    field: "Cvr",
    get displayName() {
        return translate("segment.conversion.table.column.cvr");
    },
    type: "double",
    format: "percentagesign",
    sortable: true,
    isSorted: false,
    cellComponent: BounceRate,
    headerComponent: DefaultCellHeaderRightAlign,
    sortDirection: "desc",
    get tooltip() {
        return translate("segment.conversion.table.column.cvr.tooltip");
    },
    visible: true,
    width: 160,
};
const cvrCompare = {
    field: "CvrCompare",
    get displayName() {
        return translate("segment.conversion.table.column.cvr.compare");
    },
    type: "double",
    format: "percentagesign",
    sortable: true,
    isSorted: false,
    cellComponent: BounceRate,
    headerComponent: DefaultCellHeaderRightAlign,
    sortDirection: "desc",
    get tooltip() {
        return translate("segment.conversion.table.column.cvr.compare.tooltip");
    },
    visible: false,
    width: 160,
};
const cvrDelta = {
    field: "CvrDelta",
    get displayName() {
        return translate("segment.conversion.table.column.cvr.delta");
    },
    type: "double",
    format: "percentagesign",
    sortable: true,
    isSorted: false,
    cellComponent: ChangePercentage,
    headerComponent: DefaultCellHeaderRightAlign,
    sortDirection: "desc",
    get tooltip() {
        return translate("segment.conversion.table.column.cvr.delta.tooltip");
    },
    visible: true,
    width: 160,
};
const cvrGrowth = {
    field: "CvrGrowth",
    get displayName() {
        return translate("segment.conversion.table.column.cvr.growth");
    },
    type: "double",
    format: "percentagesign",
    sortable: true,
    isSorted: false,
    cellComponent: ChangePercentage,
    headerComponent: DefaultCellHeaderRightAlign,
    sortDirection: "desc",
    get tooltip() {
        return translate("segment.conversion.table.column.cvr.growth.tooltip");
    },
    visible: false,
    width: 160,
};

const ConversionSegmentsOssTableColumnConfig = () => [
    kw,
    // swScore,
    upv,
    upvGrowth,
    cv,
    cvGrowth,
    cvr,
    cvrGrowth,
];

const ConversionSegmentsOssCompareDurationTableColumnConfig = () => [
    kw,
    // swScore,
    upvCompare,
    upv,
    upvDelta,
    cvCompare,
    cv,
    cvDelta,
    cvrCompare,
    cvr,
    cvrDelta,
];

export const conversionSegmentsOssTableConfigGen = ({ sortbyField, sortDirection }, comparedDuration) => {
    const columns = comparedDuration
        ? ConversionSegmentsOssCompareDurationTableColumnConfig()
        : ConversionSegmentsOssTableColumnConfig();
    return columns.map((col: any, idx) => {
        if (!col.sortable) {
            return col;
        }
        return {
            ...col,
            isSorted: col.field === sortbyField,
            visible: col.visible !== false,
            sortDirection: col.field === sortbyField ? sortDirection : col.sortDirection,
        };
    });
};
